/**
 * Active-state rules for section tab bars (Admin, Billing, System).
 * Keeps NavLink highlighting aligned with sidebar destinations.
 */
export function isPortalSectionTabActive(location, link) {
  if (!location || !link) {
    return false;
  }

  const pathname = location.pathname || '';
  const search = location.search || '';
  const [linkPath, linkQuery = ''] = link.split('?');
  const linkSearch = linkQuery ? `?${linkQuery}` : '';

  if (
    linkSearch === '?tab=org'
    && linkPath === '/Portal/Instructor/settings'
  ) {
    return (
      (pathname === '/Portal/Instructor/settings' && search === '?tab=org')
      || pathname === '/Portal/Instructor/organisation'
    );
  }

  if (linkPath === '/Portal/Instructor/billing' && link === '/Portal/Instructor/billing') {
    return pathname === '/Portal/Instructor/billing';
  }

  if (linkPath.startsWith('/Portal/Instructor/billing/')) {
    return pathname === linkPath;
  }

  if (linkQuery) {
    return pathname === linkPath && search === linkSearch;
  }

  return pathname === linkPath;
}
